/**
 * Edit person button.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AddEditPersonModal from 'js/Components/Modal/AddEditPersonModal';
import Button from 'js/Components/Forms/Raw/Button';
import noop from 'js/noop';
import organizationPropType from 'js/PropTypes/organization';
import personPropType from 'js/PropTypes/person';
import rolePropType from 'js/PropTypes/role';
import UserContext from 'js/Context/UserContext';

/**
 * Edit person button class.
 */
class EditPersonButton extends Component {
    static propTypes = {
        onEditPerson: PropTypes.func,
        organizations: PropTypes.arrayOf(organizationPropType),
        person: personPropType,
        roles: PropTypes.arrayOf(rolePropType),
    };

    static defaultProps = {
        onEditPerson: noop,
        organizations: [],
        person: null,
        roles: [],
    };

    /**
     * constructor
     *
     * @param {object} props Properties
     *
     * @returns {void}
     */
     constructor(props) {
        super(props);

        this.state = {
            addModalOpen: false,
        };

        // Efficient early binding.
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onEditPerson = this.onEditPerson.bind(this);
        this.onShowModal = this.onShowModal.bind(this);
    }

    /**
     * Event handler for add after modal save.
     *
     * @param {object} editPerson Edited person object.
     *
     * @returns {void}
     */
     onEditPerson(editPerson) {
        const { onEditPerson, person } = this.props;

        if (onEditPerson) {
            onEditPerson(person.id, editPerson);
        }

        this.onCloseModal();
    }

    /**
     * Event handler for modal close.
     *
     * @returns {void}
     */
     onCloseModal() {
        this.setState({
            addModalOpen: false,
        });
    }

    /**
     * Event handler for modal show.
     *
     * @returns {void}
     */
     onShowModal() {
        this.setState({
            addModalOpen: true,
        });
    }

    /**
     * Conditionally render the add/edit person modal.
     *
     * @returns {React.node|null}
     */
    renderModal() {
        const { organizations, person, roles } = this.props;
        const { addModalOpen } = this.state;

        if (addModalOpen) {
            return (
                <AddEditPersonModal
                    action="edit"
                    onPersonSaved={this.onEditPerson}
                    onClose={this.onCloseModal}
                    open={addModalOpen}
                    organizations={organizations}
                    person={person}
                    roles={roles}
                />
            );
        }

        return null;
    }

    /**
     * Render Add user button.
     *
     * @returns {React.node}
     */
    render() {
        return (
            <UserContext.Consumer>
                {({ hasPermission }) => {
                    if (hasPermission('manage.people')) {
                        return (
                            <>
                                <Button
                                    onClick={this.onShowModal}
                                >
                                    Edit
                                </Button>
                                {this.renderModal()}
                            </>
                        );
                    }

                    return null;
                }}
            </UserContext.Consumer>
        );
    }
}

export default EditPersonButton;
